export function isInteger(value: string): boolean {
  return RegExp(/^-?[0-9]+$/).test(value);
  // We only need the simplest case for now, refine as need arises.
  // Outputs lots of false negatives currently e.g. group separators ("1 000 000" returns false)
}
